import Footer from '../components/menu/footer'
import Navbar from '../components/menu/navbar'
import ContactHero from '../components/section/contactHero'
import ContactForm from '../components/forms'
import COPY from '../utils/copy'

export default function Contact() {
  return (
    <>
      <Navbar />
      <ContactHero heading={COPY.CONTACT_HEADER} subheading={COPY.CONTACT_SUBHEADER} />
      <ContactForm />
      <Footer />
    </>
  )
}
